import React from 'react';
import { Box, Divider } from '@mui/material';

const SectionDivider = ({ sx = {} }) => {
  return (
    <Box sx={{my:1, ...sx}}>
      <Divider sx={{ 
        borderBottomWidth: 4, 
        borderColor: 'primary.main',
      }} />
      <Divider sx={{ 
        borderBottomWidth: 8, 
        borderColor: 'primary.light',
      }} />
    </Box>
  );
};

export default SectionDivider; 